import { unityColorTokens } from '../../unityTokens';
import { ChronosphereColor } from './types';

export const unityPurple: ChronosphereColor = {
  50: unityColorTokens['--color-accent-vodka-50'],
  100: unityColorTokens['--color-accent-vodka-100'],
  150: unityColorTokens['--color-accent-vodka-200'],
  200: unityColorTokens['--color-accent-vodka-300'],
  300: unityColorTokens['--color-accent-vodka-400'],
  400: unityColorTokens['--color-accent-vodka-500'],
  500: unityColorTokens['--color-accent-vodka-600'],
  600: unityColorTokens['--color-accent-vodka-700'],
  700: unityColorTokens['--color-accent-vodka-800'],
  800: unityColorTokens['--color-accent-vodka-900'],
  850: unityColorTokens['--color-accent-vodka-950'],
  900: unityColorTokens['--color-accent-vodka-1000'],
  950: unityColorTokens['--color-accent-vodka-1000'],
};

export const purple: ChronosphereColor = {
  50: '#F2ECFD',
  100: '#E3D7FA',
  150: '#D3C2F6',
  200: '#C4ADF3',
  300: '#B497F0',
  400: '#A582ED',
  500: '#956DE9',
  600: '#8658E6',
  700: '#6D47BD',
  800: '#543694',
  850: '#3C256A',
  900: '#231441',
  950: '#0A0318',
};
